import { render, staticRenderFns } from "./MenuPrincipal.vue?vue&type=template&id=5a2d4f2d&"
import script from "./MenuPrincipal.vue?vue&type=script&lang=js&"
export * from "./MenuPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports